"use client";

export function ChipGroup({
  options,
  value,
  onChange,
}: {
  options: { value: string; label: string }[];
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={`rounded-full border px-3.5 py-1.5 text-sm font-medium transition ${
            value === opt.value
              ? "border-transparent bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white shadow-sm"
              : "border-slate-200 bg-white text-slate-600 hover:border-violet-300 hover:text-violet-700 dark:border-slate-700 dark:bg-[#0f172a] dark:text-slate-300 dark:hover:border-violet-500 dark:hover:text-violet-400"
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export function MultiChipGroup({
  options,
  values,
  onChange,
}: {
  options: string[];
  values: string[];
  onChange: (values: string[]) => void;
}) {
  function toggle(option: string) {
    onChange(values.includes(option) ? values.filter((v) => v !== option) : [...values, option]);
  }
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((opt) => (
        <button
          key={opt}
          type="button"
          onClick={() => toggle(opt)}
          className={`rounded-full border px-3.5 py-1.5 text-sm font-medium transition ${
            values.includes(opt)
              ? "border-transparent bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white shadow-sm"
              : "border-slate-200 bg-white text-slate-600 hover:border-violet-300 hover:text-violet-700 dark:border-slate-700 dark:bg-[#0f172a] dark:text-slate-300 dark:hover:border-violet-500 dark:hover:text-violet-400"
          }`}
        >
          {opt}
        </button>
      ))}
    </div>
  );
}

export const fieldLabelClass = "text-sm font-medium text-slate-700 dark:text-slate-300";
export const inputClass =
  "mt-1.5 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 placeholder:text-slate-400 focus:border-violet-400 focus:outline-none dark:border-slate-700 dark:bg-[#0f172a] dark:text-slate-200";
